
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Role, User, UserRole } from "@/script/apps/system/entity/SystemEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { UserService } from "@/script/apps/system/service/UserService";
import { ElMessage } from "element-plus";

@Options({})
export default class UserDetail extends BaseDetail {
  private service = new UserService();

  private roleIds: number[] = [];

  private roleList: any[] = [];

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "sys_user",
      "/sys/user",
      "/sys/user",
      this.service
    );
    data.statesName = "sys-state";
    return data;
  }

  protected initOptions() {
    super.initOptions();

    this.service.loadRoleList((data: any) => {
      const roles: Role[] = data;
      this.roleList = [];
      roles.forEach(item => {
        this.roleList.push({
          value: item.id,
          label: item.name
        });
      });
    });
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }]
  };

  public newEntity() {
    const entity: User = {};
    return entity;
  }

  afterLoad(data: any) {
    const user = this.entity as User;
    if (user.userRoles) {
      this.roleIds = [];
      user.userRoles.forEach(item => {
        this.roleIds.push(item.roleId!);
      });
    }
  }

  beforeSave() {
    const user = this.entity as User;
    user.oldUserRoles = [];
    user.oldUserRoles = user.oldUserRoles.concat(user.userRoles!);
    user.userRoles = [];
    this.roleIds.forEach(item => {
      const userRole: UserRole = { roleId: item, userId: user.id! };
      user.userRoles!.push(userRole);
    });
    return true;
  }
}
